import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Search, Loader2 } from "lucide-react";
import { http, errMsg } from "../../lib/api";

export const PriceFill = ({ kitId, reload }) => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => http.get(`/kits/${kitId}/price-fill`).then((x) => setD(x.data)).catch(() => {}), [kitId]);
  useEffect(() => { load(); }, [load]);
  const running = d?.running || d?.status === "running";
  useEffect(() => {
    if (!running) return undefined;
    const t = setInterval(async () => {
      const x = await http.get(`/kits/${kitId}/price-fill`).catch(() => null);
      if (!x) return;
      setD(x.data);
      if (!x.data.running && x.data.status !== "running") {
        toast.success(`Prices: ${x.data.filled || 0} found on the web, ${x.data.replaced || 0} venue(s) replaced, ${x.data.unverified || 0} on request`);
        reload();
      }
    }, 4000);
    return () => clearInterval(t);
  }, [running, kitId, reload]);
  const go = async () => {
    setBusy(true);
    try {
      const r = await http.post(`/kits/${kitId}/price-fill`);
      if (!r.data.venues) toast.message("No missing prices on this kit");
      else toast.message(`Looking up prices for ${r.data.venues} venue(s) — you can leave this page`);
      await load();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  if (!d) return null;
  return (
    <div data-testid="price-fill-panel" className="mb-6 flex flex-wrap items-center gap-3 rounded-lg border border-stone-200 bg-white p-4 text-sm">
      <span data-testid="price-fill-status" className="text-stone-600">
        {running ? `Looking up prices… ${d.done || 0}/${d.total || 0}${d.current ? ` — ${d.current}` : ""}`
          : `${d.gaps} venue(s) with missing prices`}
        {!running && d.status && d.status !== "running" && ` · last run: ${d.filled || 0} found, ${d.replaced || 0} replaced, ${d.unverified || 0} on request${d.status !== "done" ? ` (${d.status})` : ""}`}
      </span>
      <button data-testid="price-fill-btn" disabled={busy || running || !d.gaps} onClick={go}
        className="ml-auto inline-flex items-center gap-1.5 rounded-sm bg-[#2B2A26] px-3 py-1.5 text-xs font-bold text-white hover:bg-black transition-colors disabled:opacity-50">
        {running ? <Loader2 size={12} className="animate-spin" /> : <Search size={12} />} Fill missing prices
      </button>
    </div>
  );
};
